export default __webpack_public_path__ + "static/media/redemptions.ec8152be.svg";